import { render, staticRenderFns } from "./UtteranceEditor.vue?vue&type=template&id=2cc2ec68"
import script from "./UtteranceEditor.vue?vue&type=script&lang=js"
export * from "./UtteranceEditor.vue?vue&type=script&lang=js"
import style0 from "./UtteranceEditor.vue?vue&type=style&index=0&id=2cc2ec68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports